import EntityView, { EntityViewProps, testIds } from './EntityView';

export default EntityView;

export { testIds };

export type { EntityViewProps };
